import React, { useState } from "react";
import { Link } from "react-router-dom";
import { TopNav } from "../../../components/Navbar/Webpages/TopNav";
import Footer from "../../../components/Layout/Footer";
import { PlusIcon, MinusIcon } from "@heroicons/react/outline";
import { MdHelpOutline } from "react-icons/md";

const faqData = [
  {
    title: "What is Zam-chain Advanced Investment.?",
    content: `Zam-chain Advanced Investment. is founded by a team of professional Forex & Crypto traders who know exactly what it takes to earn the most from capital market. Our company provides a full investment service focused on the Forex and cryptocurrency trading market. Each trader in our group has more than 7 years of trading experience and successful trading records, as we know that is the exact point that support our company stability and profitability.`,
  },
  {
    title: "Is Zam-chain Advanced Investment. officially registered?",
    content:
      "Yes. Zam-chain Advanced Investment. is a legal investment company incorporated and headquartered in London. Company registration number of 39116500C",
  },
  {
    title: "Who can create an account with Zam-chain Advanced Investment.?",
    content: `Any individual or legitimate entity can avail our services. However, you need to be of legal age in your jurisdiction in order to create an account with us. `,
  },
  {
    title: "How do I create my account with Zam-chain Advanced Investment.?",
    content:
      "Registration process is very easy and will take a few moments to complete. Simply click 'Register' button on the top right of our website and fill in all the required fields.",
  },
  {
    title: "Can I have more than one account with you?",
    content:
      "No, you can't have more than one account per user unless you were given a special admin permission to have more. If you are caught by having more than 1 account without our permission, you are risking all your accounts and funds being suspended.",
  },
  {
    title:
      "What do I need to start investing with Zam-chain Advanced Investment.?",
    content:
      "First of all, you need to register a new account, select an investment plan and make a deposit of at least $500 through the popular payment systems.",
  },
  {
    title: "How many times can a user make deposits into their account?",
    content:
      "A user can make deposits in his or her account as and when they want. There is no limitation on the number of deposits that a user can make into their account.",
  },
  {
    title: "What payment methods can I use to make a deposit?",
    content:
      "For Now we accept only Bitcoin and we plan to extend the list of the accepted payment methods soon.",
  },
  {
    title: "What is the Minimum / Maximum amount allowed to deposit?",
    content:
      "The minimum amount of investment is only $500. The maximum amount is K1000000. Each investor can have an unlimited number of deposits.",
  },
  {
    title: "Can I make reinvestments?",
    content:
      "Yes, you can reinvest. However, we do not allow compounding of investments from your account balance.",
  },
  {
    title: "Do I get my investment principal back?",
    content:
      "No. Upon investment plan expiry, interest payments will cease unless the customer chooses to invest further.",
  },
  {
    title: "What is the minimum amount for withdrawal?",
    content: "The minimum withdrawal amount is $500",
  },
  {
    title: "Are there any fees to withdraw my funds?",
    content: "There are no any hidden fees to withdraw your funds.",
  },
  {
    title: "Do you have an affiliate program?",
    content:
      "Yes, you will get 3 levels referral commission 15% - 10% - 5% if your downlines make a deposit.",
  },
  {
    title: "Can I receive a referral commission without making a deposit?",
    content:
      "Yes, you can get a referral commission without making a personal deposit.",
  },
  {
    title:
      "How can I get 'Representative' status in order to increase my referral rewards?",
    content:
      "First, you need to make at least $5000 deposit. Then you will need to contact us in order to get an increased affiliate status for your account.",
  },
];

// --- Custom Accordion Component ---
const AccordionItem = ({ title, content, isOpen, onClick, index }) => {
  return (
    <div
      className={`group border border-gray-100 rounded-2xl mb-4 transition-all duration-300 overflow-hidden ${
        isOpen
          ? "bg-white shadow-lg shadow-primary/5 ring-1 ring-primary/20"
          : "bg-white shadow-sm hover:shadow-md"
      }`}
    >
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none"
      >
        <span
          className={`font-heading font-bold text-lg transition-colors ${
            isOpen ? "text-primary" : "text-gray-800 group-hover:text-primary"
          }`}
        >
          {title}
        </span>
        <div
          className={`p-2 rounded-full transition-all duration-300 ${
            isOpen
              ? "bg-primary text-white rotate-180"
              : "bg-gray-50 text-gray-400 group-hover:bg-primary/10 group-hover:text-primary"
          }`}
        >
          {isOpen ? (
            <MinusIcon className="w-5 h-5" />
          ) : (
            <PlusIcon className="w-5 h-5" />
          )}
        </div>
      </button>

      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="p-6 pt-0 text-gray-500 font-body leading-relaxed border-t border-dashed border-gray-100 mt-2">
          {content}
        </div>
      </div>
    </div>
  );
};

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState(0); // First item open by default

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-gray-50 overflow-x-hidden selection:bg-primary/20 selection:text-primary">
      <TopNav />

      {/* --- HERO SECTION --- */}
      <div className="relative h-[45vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        {/* 1. Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1639322537228-f710d846310a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
            alt="FAQ Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* 2. FULL PRIMARY OVERLAY */}
        <div className="absolute inset-0 bg-primary/90 mix-blend-multiply z-10"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent z-10"></div>

        {/* 3. Content */}
        <div className="relative z-20 container max-w-screen-xl mx-auto px-4 text-center mt-8">
          <span className="inline-block py-1 px-4 rounded-full bg-white/20 backdrop-blur-md border border-white/30 text-white text-xs font-heading font-bold tracking-widest uppercase mb-6">
            Help Center
          </span>

          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 tracking-tight drop-shadow-sm">
            Frequently Asked <br />
            <span className="text-blue-200">Questions</span>
          </h1>

          <p className="font-body text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light leading-relaxed">
            Everything you need to know about our services, billing, and
            investment plans.
          </p>
        </div>
      </div>

      {/* --- CONTENT SECTION --- */}
      <section className="py-20 md:py-28 relative">
        {/* Background Texture */}
        <div
          className="absolute inset-0 opacity-[0.03] pointer-events-none"
          style={{
            backgroundImage: "radial-gradient(#444 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        ></div>

        <div className="container max-w-screen-md mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <MdHelpOutline className="text-6xl text-primary/20 mx-auto mb-4" />
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900">
              How can we <span className="text-primary">help?</span>
            </h2>
          </div>

          <div className="space-y-4">
            {faqData.map((item, index) => (
              <AccordionItem
                key={index}
                index={index}
                title={item.title}
                content={item.content}
                isOpen={openIndex === index}
                onClick={() => handleToggle(index)}
              />
            ))}
          </div>

          {/* CTA Box */}
          <div className="mt-20 bg-white rounded-3xl p-8 md:p-12 border border-gray-100 shadow-xl shadow-primary/5 text-center">
            <h3 className="font-heading font-bold text-2xl text-gray-900 mb-3">
              Still have questions?
            </h3>
            <p className="text-gray-500 font-body mb-8">
              Can't find the answer you're looking for? Please chat to our
              friendly team.
            </p>
            <Link to="/support">
              <button className="bg-primary text-white px-8 py-3 rounded-xl font-bold shadow-lg shadow-primary/20 hover:shadow-primary/40 hover:-translate-y-1 transition-all duration-300">
                Get in Touch
              </button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FaqPage;
